import type { Article, ArticleCategory } from '../../core/types/content'

/** Zoveel artikelen onder "Lees ook". */
export const RELATED_COUNT = 2

export const articlePath = (a: Pick<Article, 'slug'>) => `/journal/${a.slug}`

/** Categorieën volgen uit de artikelen zelf: een nieuwe categorie in de backend verschijnt vanzelf. */
export function categoriesOf(articles: readonly Article[]): ArticleCategory[] {
  return Array.from(new Set(articles.map((a) => a.category)))
}

/** `null` = alle categorieën. */
export function articlesIn(articles: readonly Article[], category: ArticleCategory | null): Article[] {
  return category === null ? [...articles] : articles.filter((a) => a.category === category)
}

/** "Lees ook": eerst uit dezelfde categorie, dan de rest. Nooit het artikel zelf. */
export function relatedArticles(articles: readonly Article[], current: Article, count = RELATED_COUNT): Article[] {
  const others = articles.filter((a) => a.slug !== current.slug)
  const same = others.filter((a) => a.category === current.category)
  const rest = others.filter((a) => a.category !== current.category)
  return [...same, ...rest].slice(0, count)
}
